import React from 'react';
import { RowDragEvent } from 'ag-grid-community';
import { Box } from '@mui/material';
import AdminList from '../../../../ui/admin/AdminList';
import Footer from '../../ChannelGroupList/components/Footer';
import { ArticleSummary } from '../../../../../shared/types';
import { GroupedUserGuideScopeRow } from '../types';
import OrderedScopeChips from './OrderedScopeChips';
import userGuideOrderingColumnDefs from './columnDefs';

interface UserGuideOrderingTableProps {
    items: ArticleSummary[];
    loading: boolean;
    groups: GroupedUserGuideScopeRow[];
    selectedScopeId: string;
    onSelectScope: (scopeId: string) => void;
    onRowDragEnd: (event: RowDragEvent) => void;
    hasPendingChanges: boolean;
    saving: boolean;
    onSave: () => Promise<void>;
}

const UserGuideOrderingTable: React.FC<UserGuideOrderingTableProps> = ({
    items,
    loading,
    groups,
    selectedScopeId,
    onSelectScope,
    onRowDragEnd,
    hasPendingChanges,
    saving,
    onSave,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <AdminList
                name="user-guide-order"
                title="User Guide Order"
                items={items}
                loading={loading}
                columns={userGuideOrderingColumnDefs}
                showAdd={false}
                pagination={false}
                showCaption={false}
                renderGridWhenEmpty
                entityForCaptionText="user guides"
                defaultColDef={{ sortable: false }}
                aboveTable={
                    <OrderedScopeChips
                        groups={groups}
                        selectedScopeId={selectedScopeId}
                        onSelectScope={onSelectScope}
                    />
                }
                gridOptions={{
                    pagination: false,
                    rowDragManaged: true,
                    animateRows: true,
                    onRowDragEnd,
                }}
                footer={
                    <Footer
                        wrapperSx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            mt: 2,
                        }}
                        disabled={!hasPendingChanges || saving}
                        onSave={onSave}
                        buttonId="save-user-guide-order-button"
                    />
                }
            />
        </Box>
    );
};

export default UserGuideOrderingTable;
